export const easyComplianceApp = {
  id: 49,
  name: "easycompliance",
  label: "easy Compliance",
  showTestConnection: false,
  logo: process.env.BASE_URL + "media/shopLogos/easyCompliance.png",
  areaBlacklist: ["productSelection", "journal", "migration"],
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_EASY_COMPLIANCE_PRESET_ID
  }
};
